import { render, staticRenderFns } from "./FolderAndProjectBreadcrumb.vue?vue&type=template&id=31de4746&scoped=true"
import script from "./FolderAndProjectBreadcrumb.vue?vue&type=script&lang=js"
export * from "./FolderAndProjectBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./FolderAndProjectBreadcrumb.vue?vue&type=style&index=0&id=31de4746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de4746",
  null
  
)

export default component.exports